import { useEffect } from 'react';
import { FormInput } from '@/components/FormInput';
import { FormSelect } from '@/components/FormSelect';
import type { ManagerFieldProps } from './managerField.types';

export function ManagerField({ label, value, onChange, suggestions, error, disabled = false, helperText }: ManagerFieldProps) {
    useEffect(() => {
        if (!value && suggestions[0]) onChange(suggestions[0].collaborator.email);
    }, [value, suggestions, onChange]);

    if (suggestions.length === 0) {
        return (
            <FormInput
                label={label}
                name="managerEmail"
                type="email"
                value={value}
                onChange={event => onChange(event.target.value)}
                error={error}
                helperText={helperText}
                disabled={disabled}
                required
            />
        );
    }

    return (
        <FormSelect
            label={label}
            name="managerEmail"
            value={value}
            onChange={event => onChange(event.target.value)}
            options={suggestions.map(item => ({ value: item.collaborator.email, label: item.collaborator.name }))}
            error={error}
            helperText={helperText}
            disabled={disabled}
            required
        />
    );
}
